import { FC } from "react";
import styled, { keyframes } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

const bounce = keyframes`
  0%, 80%, 100% { opacity: .2; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-2px); }
`;

export const ChatLoaderWrapper = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "chat-loader-wrapper",
})`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 15px;
  height: 14px;
  overflow: visible;

  span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #000;
    animation: ${bounce} 1.2s infinite;
  }

  span:nth-child(2) {
    animation-delay: 0.15s;
  }
  span:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

export const AiAdvisorChatLoader: FC = () => (
  <ChatLoaderWrapper>
    <span />
    <span />
    <span />
  </ChatLoaderWrapper>
);
